<template>
  <ApolloAccordion :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridAccordionEditor",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
